import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * SEOHead - Dynamically updates canonical URL and meta tags based on current route
 * Fixes "Duplicate without user-selected canonical" issue in Google Search Console
 */
export default function SEOHead({ title, description }) {
  const location = useLocation();
  const baseUrl = 'https://aftersales.pro';
  
  useEffect(() => {
    // Update canonical URL
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.rel = 'canonical';
      document.head.appendChild(canonicalLink);
    }
    
    // Clean path - remove trailing slashes and query params for canonical
    let cleanPath = location.pathname.replace(/\/+$/, '') || '/';
    const canonicalUrl = cleanPath === '/' ? baseUrl : `${baseUrl}${cleanPath}`;
    canonicalLink.href = canonicalUrl;
    
    // Update OG URL
    let ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.content = canonicalUrl;
    }
    
    // Update Twitter URL
    let twitterUrl = document.querySelector('meta[property="twitter:url"]');
    if (twitterUrl) {
      twitterUrl.content = canonicalUrl;
    }
    
    // Update title if provided
    if (title) {
      document.title = title;
      const ogTitle = document.querySelector('meta[property="og:title"]');
      const twitterTitle = document.querySelector('meta[property="twitter:title"]');
      if (ogTitle) ogTitle.content = title;
      if (twitterTitle) twitterTitle.content = title;
    }
    
    // Update description if provided
    if (description) {
      const metaDesc = document.querySelector('meta[name="description"]');
      const ogDesc = document.querySelector('meta[property="og:description"]');
      const twitterDesc = document.querySelector('meta[property="twitter:description"]');
      if (metaDesc) metaDesc.content = description;
      if (ogDesc) ogDesc.content = description;
      if (twitterDesc) twitterDesc.content = description;
    }
    
  }, [location.pathname, title, description]);
  
  return null; // This component doesn't render anything
}
